// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';
import { Route, Routes } from "react-router-dom";

// import modules
import TopMenuSpaced from '../Containers/TopMenuSpaced';
import BottomMenuSpaced from '../Containers/BottomMenuSpaced';

// import pages
import PageHome from '../../pages/PageHome/PageHome';
import PageAbout from '../../pages/PageAbout/PageAbout';
import PageContacts from '../../pages/PageContacts/PageContacts';
import PageNotFound from '../../pages/PageNotFound/PageNotFound';
import PagePedalsMFBZ from '../../pages/PagePedalsMFBZ/PagePedalsMFBZ';
import PagePedalsRFFZ from '../../pages/PagePedalsRFFZ/PagePedalsRFFZ';
import PagePickupWinderCNC from '../../pages/PagePickupWinderCNC/PagePickupWinderCNC';
import PagePickupWinderManual from '../../pages/PagePickupWinderManual/PagePickupWinderManual';
import PagePrivacy from '../../pages/PagePrivacy/PagePrivacy';
import PageTerms from '../../pages/PageTerms/PageTerms';
import PageDisclaimer from '../../pages/PageDisclaimer/PageDisclaimer';

export default function SiteRoutes() {
    return (
        <>
            <Routes>
                <Route path='*' element={<><TopMenuSpaced /><PageNotFound /><BottomMenuSpaced /></>} />
                <Route exact path='/' element={<><PageHome /></>} />
                <Route path="/about" element={<><TopMenuSpaced /><PageAbout /></>} />
                <Route path="/privacypolicy" element={<><TopMenuSpaced /><PagePrivacy /><BottomMenuSpaced /></>} />
                <Route path="/termsandconditions" element={<><TopMenuSpaced /><PageTerms /><BottomMenuSpaced /></>} />
                <Route path="/disclaimer" element={<><TopMenuSpaced /><PageDisclaimer /><BottomMenuSpaced /></>} />
                <Route path="/contacts" element={<><TopMenuSpaced /><PageContacts /><BottomMenuSpaced /></>} />
                <Route path="/pedals/fuzz-rffz" element={<><TopMenuSpaced /><PagePedalsRFFZ /><BottomMenuSpaced /></>} />
                <Route path="/pedals/muff-mfbz" element={<><TopMenuSpaced /><PagePedalsMFBZ /><BottomMenuSpaced /></>} />
                <Route path="/pickupwindingmachine/manual" element={<><TopMenuSpaced /><PagePickupWinderManual /><BottomMenuSpaced /></>} />
                <Route path="/pickupwindingmachine/cnc" element={<><TopMenuSpaced /><PagePickupWinderCNC /><BottomMenuSpaced /></>} />
            </Routes>
        </>
    );
}
